module.exports = __webpack_public_path__ + "img/avatar-javier-lopez.91bf56d1.jpg";